import { useMutation } from 'react-query';

import { updateNotificationPreferences } from 'services/user';

export default function useResourceMuteNotifications() {
  return useMutation(
    ({
      notifiable_type,
      notifiable_uuid,
    }: {
      notifiable_type: string;
      notifiable_uuid: string;
    }) => {
      return updateNotificationPreferences({ notifiable_type, notifiable_uuid });
    },
    {
      onError: (error) => {
        console.error('Error submitting notification preferences:', error);
      },
    }
  );
}
